<ng-container [ngTemplateOutlet]="magnifyTemplate" [ngTemplateOutletContext]="{ templateToMagnify: contentTemplate }"></ng-container>

<ng-template #magnifyTemplate let-templateToMagnify="templateToMagnify">
    <div class="magnify-container"
        (mouseenter)="onMouseEnter($event)"
        (mouseleave)="onMouseLeave()">
        <div>
            <ng-container [ngTemplateOutlet]="templateToMagnify"></ng-container>
        </div>
</div>

<!-- Portal template -->
<ng-template #overlayContent>
    <div class="magnify-overlay">
    <div class="svg-magnifier">
        <div class="magnified-content">
            <ng-container [ngTemplateOutlet]="templateToMagnify"></ng-container>
        </div>
    </div>
    </div>
</ng-template>
        
    
</ng-template>